import { useMemo } from 'react';
import { Grid } from '@mui/material';
import moment from 'moment';
import { CustomChip } from '../../../../components/chip/Chip';

const ESTADO_PACIENTE = {
  alta: 'Alta',
  nuevo: 'Nuevo',
  probable: 'Probable',
  servicio: 'Servicio',
  suspendido: 'Suspendido',
}

const ESTADO_CONTRATO = {
  inactivo: 'Inactivo',
  servicio: 'En Servicio',
  suspendido: 'Suspendido',
}

const CONSENTIMIENTO_SI = 'SI';
const CONSENTIMIENTO_NO = 'NO';
const CONSENTIMIENTO_NA = 'N/A';

const PatientCard = ({
  evaluacionSelected,
  estadosPacienteOptions,
  contratoInicial
}) => {
  // console.log("evaluacionSelected", evaluacionSelected);
  const estadoContratoChip = useMemo(() => {
    if (!evaluacionSelected || !evaluacionSelected.estadoAsistencial) {
      return <CustomChip label={'-'} isLightGray title={'-'} />;
    }

    const estadoContrato = evaluacionSelected.estadoAsistencial;

    switch (estadoContrato) {
      case ESTADO_CONTRATO.servicio:
        return <CustomChip label={estadoContrato} isGreen title={estadoContrato} />;
      case ESTADO_CONTRATO.suspendido:
        return <CustomChip label={estadoContrato} isRed title={estadoContrato} />;
      case ESTADO_CONTRATO.inactivo:
        return <CustomChip label={evaluacionSelected?.estadoAsistencial} isYellow title={evaluacionSelected?.estadoAsistencial} />;
      default:
        return <CustomChip label={estadoContrato || '-'} isLightGray title={estadoContrato || '-'} />;
    }
  }, [evaluacionSelected]);


  const getEstadoPaciente = () => {
    const estadoPaciente = estadosPacienteOptions.find(
      (estado) => estado.id === evaluacionSelected.idEstadoPaciente
    );

    if (!estadoPaciente) {
      return <CustomChip label={'-'} isLightGray title={'-'} />;
    }

    switch (estadoPaciente.displayName) {
      case ESTADO_PACIENTE.alta:
      case ESTADO_PACIENTE.nuevo:
      case ESTADO_PACIENTE.probable:
        return <CustomChip label={estadoPaciente.displayName} isYellow title={estadoPaciente.displayName} />;
      case ESTADO_PACIENTE.servicio:
        return <CustomChip label={estadoPaciente.displayName} isGreen title={estadoPaciente.displayName} />;
      case ESTADO_PACIENTE.suspendido:
        return <CustomChip label={estadoPaciente.displayName} isRed title={estadoPaciente.displayName} />;
      default:
        return <CustomChip label={'-'} isLightGray title={'-'} />;
    }
  };

  const getChipConsentimiento = () => {
    return <CustomChip
      label={evaluacionSelected.consentimiento}
      isGreen={evaluacionSelected.consentimiento === CONSENTIMIENTO_SI}
      isRed={evaluacionSelected.consentimiento === CONSENTIMIENTO_NO}
      isGray={evaluacionSelected.consentimiento === CONSENTIMIENTO_NA}
      title={evaluacionSelected.consentimiento}
    />;
  }

  return (
    <Grid container className='patient-card'>
      <Grid size={{ xs: 12 }}>
        <div className='section-title'>Datos paciente</div>
      </Grid>
      <Grid container spacing={2} size={{ xs: 12 }}>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2 }}>
          <div className='patient-card-label'>Paciente</div>
          <div>{evaluacionSelected?.paciente}</div>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 1 }}>
          <div className='patient-card-label'>HC</div>
          <div>{evaluacionSelected?.idPaciente}</div>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 1 }}>
          <div className='patient-card-label'>Edad</div>
          <div>{isNaN(evaluacionSelected?.edad) ? '-' : evaluacionSelected?.edad}</div>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 1 }}>
          <div className='patient-card-label'>Sexo</div>
          <div>{evaluacionSelected?.sexo}</div>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 1 }}>
          <div className='patient-card-label'>Ingreso</div>
          <div>{moment(evaluacionSelected?.fechaIngreso)?.format('DD/MM/YYYY')}</div>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2 }}>
          <div className='status-container'>
            <div>
              <div className='patient-card-label'>Estado del Paciente</div>
              <div>{getEstadoPaciente()}</div>
            </div>
          </div>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2 }}>
          <div className='status-container'>
            <div>
              <div className='patient-card-label'>Estado Asistencial</div>
              <div>{estadoContratoChip}</div>
            </div>
          </div>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2 }}>
          <div className='status-container'>
            <div>
              <div className='patient-card-label'>Consentimiento</div>
              <div>{getChipConsentimiento()}</div>
            </div>
          </div>
        </Grid>
      </Grid>

      <Grid className='contract-section' size={{ xs: 12 }}>
        <div className='section-title'>Contrato inicial</div>
      </Grid>

      <Grid container spacing={2} size={{ xs: 12 }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <div className='patient-card-label'>Contrato</div>
          <div>{`${contratoInicial?.idEvaluacion} (${moment(contratoInicial?.fechaDesde).format('DD/MM/YYYY')} - ${moment(contratoInicial?.fechaHasta).format('DD/MM/YYYY')})`}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <div className='patient-card-label'>Plan</div>
          <div>{`#(${contratoInicial?.codigoSap}) ${contratoInicial?.modulo} - ${contratoInicial?.nombrePlan}`}</div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PatientCard;
